/* eslint-disable import/no-mutable-exports */
import {
    Loadable,
    RecoilState,
    RecoilValue,
    useRecoilCallback,
    useRecoilTransactionObserver_UNSTABLE,
} from 'recoil';

// This is a workaround from https://github.com/facebookexperimental/Recoil/issues/289 to access recoil state outside of react.
// As of today 22/04/2021 this feature is missing for the recoil library.
// TODO: Refactor entire file when this feature is implemented.

// getRecoilExternalState and setRecoilExternalState can only be used when RecoilExternalStatePortal has been rendered in the react tree.
export let getRecoilExternalState: <T>(
    recoilValue: RecoilValue<T>,
) => Loadable<T> = undefined as never;

export let setRecoilExternalState: <T>(
    recoilVal: RecoilState<T>,
    valOrUpdater: ((currVal: T) => T) | T,
) => void = undefined as never;

export const RecoilExternalStatePortal = (): JSX.Element => {
    // We need to update the RecoilGetLoadable every time there's a new snapshot
    // Otherwise we will load old values from when the component was mounted
    useRecoilTransactionObserver_UNSTABLE(({ snapshot }) => {
        getRecoilExternalState = snapshot.getLoadable;
    });

    // We only need to assign RecoilSet once because it's not temporaly dependent like get is
    void useRecoilCallback(({ set }) => {
        setRecoilExternalState = set;

        return async () => {};
    })();

    return <></>;
};
